import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { Panel, Spinner } from "../ui-kit";
import { toast } from "sonner";
import { Empty } from "../team/shared";

function Bar({ pct, color }) {
  return <div className="h-1.5 bg-white/5 w-full"><div className="h-full transition-[width] duration-500" style={{ width: `${pct}%`, background: color }} /></div>;
}

export function LeadStats({ refreshKey }) {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    client.get("/partners-leads/stats", { params: { month } }).then(({ data }) => setD(data)).catch((e) => toast.error(apiErr(e)));
  }, [month, refreshKey]);
  const tot = (k) => (d?.rows || []).reduce((a, r) => a + r[k], 0);
  return (
    <Panel title="Partner Lead Stats" testid="lead-stats-panel"
      right={<input data-testid="lead-stats-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1 text-xs text-white focus:border-gold focus:outline-none" />}>
      {!d ? <Spinner /> : d.rows.length === 0 ? <Empty testid="lead-stats-empty" text="No partners yet." /> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[11px] uppercase tracking-widest text-slate-500 text-left">
              {["Partner", "Received", "Contacted", "Converted", ""].map((h) => <th key={h} className="px-4 py-2 font-normal">{h}</th>)}
            </tr></thead>
            <tbody>
              {d.rows.map((r) => (
                <tr key={r.member_id} data-testid={`lead-stats-row-${r.member_id}`} className="border-t border-[color:var(--border-subtle)]">
                  <td className={`px-4 py-2.5 ${r.active ? "text-white" : "text-slate-500"}`}>{r.name}</td>
                  <td className="px-4 py-2.5 font-mono text-slate-200">{r.received}</td>
                  <td className="px-4 py-2.5 font-mono text-slate-200">{r.contacted} <span className="text-[11px] text-slate-500">({r.contact_rate}%)</span></td>
                  <td className="px-4 py-2.5 font-mono text-gold">{r.converted} <span className="text-[11px] text-slate-500">({r.conversion_rate}%)</span></td>
                  <td className="px-4 py-2.5 w-40 space-y-1"><Bar pct={r.contact_rate} color="#94A3B8" /><Bar pct={r.conversion_rate} color="var(--gold)" /></td>
                </tr>
              ))}
              <tr className="border-t border-[color:var(--border-strong)] text-xs" data-testid="lead-stats-total">
                <td className="px-4 py-2.5 uppercase tracking-wider text-slate-500">Total</td>
                <td className="px-4 py-2.5 font-mono text-white">{tot("received")}</td>
                <td className="px-4 py-2.5 font-mono text-white">{tot("contacted")}</td>
                <td className="px-4 py-2.5 font-mono text-gold">{tot("converted")}</td>
                <td />
              </tr>
            </tbody>
          </table>
          <p className="px-4 py-2 text-[11px] text-slate-500">Received = leads created this month & assigned to the partner · Contacted = moved beyond "New Lead" · Converted = Broker Verified / Premium Activated / Renewal Due.</p>
        </div>
      )}
    </Panel>
  );
}
